import React, { Component, Fragment } from "react";
import moment from "moment";
import Linkify from "react-linkify";
import ImageLoad from "../../Common/ImageLoad";
import ImagePlaceholder from "../../Common/ImagePlaceholder";
import DraggableBubble from "./DraggableBubble";
import Seen from "./Seen";
import { Document, Page, pdfjs } from "react-pdf";
import MMSMedia from "./MMSMedia";
import AttachmentContainer from "./AttachmentContainer";
import ReplyTo from "./ReplyTo";
import DOMPurify from "dompurify";
import parse from "html-react-parser";
import { connect } from "react-redux";
import { setAttentionedMessage, createThread, sendFollowUp } from "../../../actions/ThreadAction";
import ContactSelector from "../../TabList/ConferenceTab/ContactSelector";
import Parse from "parse";
import ReactTooltip from "react-tooltip";

export class FromMe extends Component {
  constructor(props) {
    super(props);

    this.state = {
      playing: false,
      pos: 0,
      isExpanded: false,
      showViewMore: false,
      attentioned_users: [],
      user: Parse.User.current().id,
      userName: Parse.User.current().get("displayName"),
      render: false,
    };

    this.handleTextDisplay = this.handleTextDisplay.bind(this);
    this.highlightSpecificWords = this.highlightSpecificWords.bind(this);
    this.handleViewMoreDisplay = this.handleViewMoreDisplay.bind(this);
    this.handleTogglePlay = this.handleTogglePlay.bind(this);
    this.handlePosChange = this.handlePosChange.bind(this);
    this.resendMessage = this.resendMessage.bind(this);
  }

  resendMessage() {
    this.props.resendMessage();
  }

  getFileExtention(name) {
    return name.substr((~-name.lastIndexOf(".") >>> 0) + 2);
  }

  handleTogglePlay() {
    this.setState({
      playing: !this.state.playing,
    });
  }

  handlePosChange(e) {
    this.setState({
      pos: e.originalArgs[0],
    });
  }

  handleReply() {
    const { message } = this.props;
    // let time = moment(new Date(message.createdAt)).format('MM[/]D[/]YY HH[:]mm');
    // let reply = "\"Re: " + message.text + "\" -- " + message.user.firstName + " - " + time + "\n------------------\n\n";
    this.props.initReply(message);
  }

  openLightbox(url) {
    this.props.openLightbox(url);
  }

  getPdfThumbnail(thumbnail) {
    if (!thumbnail) return "";

    const url = thumbnail.url;

    const ext = this.getFileExtention(url).toLowerCase();

    if (ext === "pdf") return "";

    return url;
  }

  highlightSpecificWords = ({ text, highlightWords }) => {
    const highlightText = (text, words) => {
      const escapedHighlightWords = words.map((word) => word.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"));
      const pattern = new RegExp(`(${escapedHighlightWords.join("|")})`, "gi");
      const parts = text.split(pattern);
      if (highlightWords.length > 0) {
        return parts.map((part, index) =>
          pattern.test(part) ? (
            <span key={index} style={{ color: "#2193f3", fontWeight: "bold" }}>
              {part}
            </span>
          ) : (
            part
          )
        );
      } else {
        return text;
      }
    };

    // const html_string = highlightText(text, highlightWords);
    const htmlWithBreaks = text ? text.replace(/\n/g, "<br />") : "";
    const html_string = htmlWithBreaks;
    const cleanHTML = DOMPurify.sanitize(html_string);

    // return <div dangerouslySetInnerHTML={{ __html: cleanHTML }} />;
    return parse(cleanHTML);
  };

  // not currently used
  handleTextDisplay(text = "", isViewMore) {
    const { isExpanded, attentioned_users } = this.state;
    const textLength = text.length;

    const lines = text.split(/\r\n|\r|\n|<br\s*\/?>/).length;
    const lineSlice = lines > 10 ? lines - 10 : 0;
    const linesArray = text.split(/\r?\n|\r|<br\s*\/?>/);
    const remainingLines = linesArray.slice(0, -lineSlice);
    const textSlice = remainingLines.join("\n");

    if (textLength >= 500) {
      return this.highlightSpecificWords({
        text: `${text.substr(0, 500)}...`,
        highlightWords: attentioned_users,
      });
    }
    return lines <= 10
      ? this.highlightSpecificWords({ text, highlightWords: attentioned_users })
      : this.highlightSpecificWords({
          // text: `${text.substr(0, 700)}...`,
          text: `${textSlice}...`,
          highlightWords: attentioned_users,
        });
  }

  handleViewMoreDisplay(bool) {
    this.setState({ isExpanded: bool });
  }

  handleGoToThread(threadId, message, objectId) {
    message.objectId = objectId;
    this.props.setAttentionedMessage(message);
    this.props.createThread(message, "message");
    this.props.history.push({
      pathname: "/u/" + threadId,
    });
  }

  handleMessageReaction(message, reaction, reactionId, click) {
    let index = null;
    const copyMessage = { ...message };

    if (reaction === click) {
      // Remove same click reaction
      index = message.reactions.findIndex((item) => item.objectId === reactionId);
      message.reactions.splice(index, 1);
    } else if (reactionId) {
      // Update reaction based on click (dummy reaction)
      index = message.reactions.findIndex((item) => item.objectId === reactionId);

      if (index >= 0) {
        message.reactions[index].reaction = reaction;
      } else {
        message.reactions = [{ reaction: reaction }];
      }
    } else {
      // Create new reaction (dummy rection)
      if (message.reactions) {
        message.reactions.push({
          reaction: reaction,
          objectId: "123",
          user: {
            objectId: this.state.user,
            displayName: this.state.userName,
          },
        });
        index = message.reactions.length - 1;
      } else {
        message.reactions = [
          {
            reaction: reaction,
            objectId: "123",
            user: {
              objectId: this.state.user,
              displayName: this.state.userName,
            },
          },
        ];
        index = 0;
      }
    }

    this.props.handleMessageReaction(reactionId, message.objectId, reaction, click).then((res) => {
      // Update reaction from response
      if (res === "reactionId not exists") {
        message = copyMessage;
      } else if (res && res != "reactionId not exists") {
        message.reactions[index ? index : 0] = res;
      }
      this.setState((prev) => ({ render: !prev.render }));
    });
  }

  getPicture() {}

  componentDidMount() {
    const { message, threadType = "group" } = this.props;
    if (message.attention && message.attention.length > 0 && threadType === "group") {
      const attentioned_users = message.attention.map((item) => `@${item.firstName}`);
      this.setState({ attentioned_users });
    }
  }

  containsAllChars(str, chars) {
    for (let i = 0; i < str.length; i++) {
      if (!chars.includes(str[i])) {
        return false;
      }
    }
    return true;
  }

  handleFollowUp(message) {
    this.props.sendFollowUp(message.objectId).then((res) => {
      this.setState((prev) => ({ render: !prev.render }));
    });
  }

  render() {
    let { message, continuesMessage, isCCM, isChecked, threadType = "group" } = this.props;
    const { attentioned_users } = this.state;

    let Picture,
      Video,
      Audio,
      hasPicture = false,
      AvatarImage,
      isPicture = false,
      isPDF = false,
      filename,
      Break = [],
      SeenArray = [],
      hasAudio = false,
      audioUrl = "",
      audioType = "",
      bubbleClass = "from-me",
      hasPDF = false;

    const seenContainer = {
      fontSize: "12px",
      margin: "2px 3px 0 8px",
      color: "rgba(0, 0, 0, .50)",
      fontWeight: "400",
      lineHeight: "12px",
      display: "flex",
      flexFlow: "wrap",
    };
    let themNameStyle = {
      paddingBottom: "10px",
      paddingLeft: "42px",
      display: "inherit",
    };

    let containerStyle = {};

    let textStyle = {
      display: "block",
    };

    if (message.forwardedToCCM) {
      bubbleClass = "from-me-forwarded";
    }

    if (continuesMessage) {
      containerStyle = {
        marginBottom: "0",
      };
      if (bubbleClass === "from-me-forwarded") {
        bubbleClass = "from-me-forwarded-continues";
      } else {
        bubbleClass = "from-me-continues";
      }
    }

    if (typeof message.newMessageStatus === "undefined" || message.newMessageStatus === "") {
      themNameStyle.display = "none";
    }

    if (!message.user.picture) {
      AvatarImage = require("../../../assets/images/default.png");
    } else {
      AvatarImage = message.user.picture.url;
    }

    /**
     * Check if picture object is pdf or picture
     */
    if (typeof message.picture !== "undefined") {
      if (typeof message.picture.url !== "undefined") {
        let ext;
        if (typeof message.picture.name === "undefined") {
          ext = this.getFileExtention(message.picture.file.name).toLowerCase();
        } else {
          ext = this.getFileExtention(message.picture.name).toLowerCase();
        }
        if (ext === "pdf") {
          isPDF = true;

          const thumbUrl = this.getPdfThumbnail(message.thumbnail);

          Picture = thumbUrl ? (
            <ImageLoad openLightbox={() => {}} imageURL={thumbUrl} />
          ) : (
            <ImagePlaceholder type="pdf" />
          );
        } else {
          isPicture = true;
          Picture = (
            <ImageLoad
              openLightbox={() => this.props.openLightbox(message.picture.url)}
              imageURL={message.picture.url}
              fromThread={true}
            />
          );
        }
      }
    }

    if (message.file) {
      if (message.file.type === "audio/mp3") {
        audioUrl = URL.createObjectURL(message.file);
        audioType = message.file.type;
        hasAudio = true;
      }
    }

    const { smsFrom, mmsContentType } = message;

    /**
     * Check if video
     */
    if (typeof message.video != "undefined") {
      if (typeof message.video.url != "undefined") {
        Video = (
          <video key={1} style={{ marginBottom: "15px", display: "block", width: "100%" }} controls>
            <source src={message.video.url} />
            Your browser does not support HTML5 video.
          </video>
        );
      }
    }
    /**
     * Check if pdf
     */
    if (isPDF) {
      if (typeof message.filename !== "undefined") {
        filename = message.filename;
      } else {
        filename = message.picture.name;
      }

      if (message.text === "") {
        // Do nothing
      } else {
        if (typeof message.text !== "undefined") {
          Break.push(<br key={1} />);
          Break.push(<br key={2} />);
        }
      }
    }

    if (message.attachments && message.attachments.length) {
      if (message.attachments[0].file) {
        if (message.attachments[0].fileType) {
          if (message.attachments[0].fileType.match("image/.*") || message.attachments[0].fileType === "photo") {
            isPicture = true;
            Picture = (
              <ImageLoad
                openLightbox={this.openLightbox.bind(this, message.attachments[0].file.url)}
                imageURL={message.attachments[0].file.url}
              />
            );
          } else if (message.attachments[0].fileType.match("audio/.*")) {
            audioUrl = message.attachments[0].file.url;
            audioType = message.attachments[0].fileType;
            hasAudio = true;
          } else if (
            message.attachments[0].fileType.match("file/pdf") ||
            message.attachments[0].fileType.match("application/pdf")
          ) {
            hasPDF = true;
            // isPDF = true;
            // pdfURL = message.attachments[0].file.url;
            // filename = message.attachments[0].file.name;
            // Picture = <img key={1} src="../../images/pdf.png" alt={message.attachments[0].file.url} className="img-fluid" style={{display: 'inline-block', width: "20px", height: "20px",marginBottom: "15px"}} />;
          }
        }
      }
    }

    if (hasAudio) {
      Audio = (
        <audio controls style={{ display: "block", marginBottom: "10px", marginTop: "10px" }}>
          <source src={audioUrl} type={audioType} />
          Your browser does not support the audio element.
        </audio>
      );
    }

    const seenBy = this.props.seenBy();
    for (let x = 0; x < seenBy.length; x++) {
      let url;
      if (typeof seenBy[x].picture == "undefined") {
        url = "../images/default.png";
      } else {
        url = seenBy[x].picture.url;
      }
      const name = seenBy[x].firstName + " " + seenBy[x].lastName;
      SeenArray.push(<Seen key={seenBy[x].objectId} url={url} name={name} />);
    }

    // Render attentioned users
    let attentioned;

    if (typeof message.attention !== "undefined") {
      attentioned = message.attention
        .filter((user) => !message.text.includes(`@${user.firstName}`))
        .map((user) => {
          return "@" + user.firstName;
        })
        .join(", ");
    }

    const { replyTo, replyingTo, text = "" } = message;

    let element = document.getElementById(`text_${message.objectId}`);
    if (message.newMessageStatus === "sending" || message.newMessageStatus === "") {
      element = document.getElementById(`text_${message.threadId}`);
    }
    const lineHeight = element ? parseFloat(getComputedStyle(element).lineHeight) : 0;
    const line = element ? element.offsetHeight / lineHeight : 0;
    // const moreLines = line > 11;
    const moreLines = element ? element.offsetHeight >= 352 : false;

    // let lines = (message.text || "").split(/\r\n|\r|\n|<br\s*\/?>/).length;
    // let letters = message.text ? message.text.length : 0;

    let themDate = this.props.messageTimestamp(message.createdAt);

    let countCheck = 0,
      countThumbsUp = 0,
      countQuestion = 0,
      userReact = "",
      reactionId = null,
      rcLoading = false,
      usersCheck = [],
      usersThumbsUp = [],
      usersQuestion = [],
      objCheck = { reaction: ":check:" },
      objThumbsUp = { reaction: ":thumbsup:" },
      objQuestion = { reaction: ":question:" };

    const propsLastSeenBy = (this.props.lastSeenBy || [])
      .filter((item) => item.lastReadMessageId === message.objectId)
      .map((item) => item.reader);
    const messageLastSeenBy = message.lastSeenBy || [];
    const combinedLastSeenBy = [...propsLastSeenBy, ...messageLastSeenBy];
    const removeUser = combinedLastSeenBy.filter((item) => item.objectId !== this.state.user);
    const removeDuplicate = removeUser.filter(
      (item, index, self) => index === self.findIndex((t) => t.objectId === item.objectId)
    );
    const lastSeenBy = removeDuplicate;

    if (message.reactions) {
      for (const [index, react] of message.reactions.entries()) {
        if (react.reaction === ":check:") {
          countCheck++;
          objCheck.count = (objCheck.count || 0) + 1;
          usersCheck.push(
            react.user ? react.user.displayName + (react.user.objectId === this.state.user ? " (You)" : "") : ""
          );
          if (react.user ? react.user.objectId === this.state.user : false) {
            objCheck.id = react.objectId;
          }
        } else if (react.reaction === ":thumbsup:") {
          countThumbsUp++;
          objThumbsUp.count = (objThumbsUp.count || 0) + 1;
          usersThumbsUp.push(
            react.user ? react.user.displayName + (react.user.objectId === this.state.user ? " (You)" : "") : ""
          );
          if (react.user ? react.user.objectId === this.state.user : false) {
            objThumbsUp.id = react.objectId;
          }
        } else if (react.reaction === ":question:") {
          countQuestion++;
          objQuestion.count = (objQuestion.count || 0) + 1;
          usersQuestion.push(
            react.user ? react.user.displayName + (react.user.objectId === this.state.user ? " (You)" : "") : ""
          );
          if (react.user ? react.user.objectId === this.state.user : false) {
            objQuestion.id = react.objectId;
          }
        }
        if (react.user ? react.user.objectId === this.state.user : false) {
          reactionId = react.objectId;
          userReact = react.reaction;
        }
      }
    }
    const hasAllChar = message.attention.length
      ? this.containsAllChars(message.attention[0].displayName, message.text)
      : false;

    const date = message.actionItem ? new Date(message.actionItem.createdAt) : new Date();
    const now = new Date();
    const diffMs = now - date;
    const diffHours = diffMs / (1000 * 60 * 60);
    const isPast3Days = diffHours > 72;

    const toDateOnly = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
    const { date: filterDate } = this.props.filterDate;
    const d1 = filterDate ? toDateOnly(new Date(filterDate)) : {};
    const d2 = toDateOnly(new Date());
    const isSameDate = filterDate ? d1.getTime() === d2.getTime() : false;

    return (
      <li className="Bubble-List-Container" style={containerStyle} id={`id_${message.objectId}`}>
        <div className="_me-container">
          <div className="_avatar-column">
            <div className="acR"></div>
            <div className="avatar">
              <img src={AvatarImage} />
            </div>
          </div>
          <div className="_me-column" style={{ position: "relative" }}>
            <div
              aria-haspopup="true"
              aria-expanded="false"
              className={"bubble " + bubbleClass}
              style={{
                cursor: "pointer",
                overflow: "hidden",
                paddingBottom:
                  message.actionItem && message.actionItem.status === "PENDING" && isPast3Days ? "15px" : "",
                marginBottom:
                  message.actionItem && message.actionItem.status === "PENDING" && isPast3Days ? "15px" : "",
              }}
              // title={moment(message.createdAt).format("MMMM D, YYYY [at] LTS Z")}
              title={themDate}
            >
              {replyingTo && replyingTo.length ? (
                replyingTo.map((replyTo) => {
                  return <ReplyTo replyTo={replyTo} />;
                })
              ) : replyTo ? (
                <ReplyTo replyTo={replyTo} />
              ) : (
                ""
              )}

              {message.attachments && message.attachments.length ? (
                <AttachmentContainer attachments={message.attachments} onOpen={(url) => this.openLightbox(url)} />
              ) : (
                <div>
                  {isPDF ? (
                    <div onClick={() => window.open(message.picture.url, "_blank")} style={{ cursor: "pointer" }}>
                      {Picture}
                    </div>
                  ) : (
                    Picture
                  )}
                  {Audio}
                  {Video}
                  {isPDF ? (
                    <a
                      ref={(p) => (this.pdf = p)}
                      style={{ textDecoration: "underline", marginLeft: "3px" }}
                      href={message.picture.url}
                      target="_blank"
                    >
                      {filename}
                    </a>
                  ) : null}
                </div>
              )}
              {smsFrom && mmsContentType ? (
                <MMSMedia message={message} onClickImage={() => this.props.onClickMMS(message.mmsUrl)} />
              ) : (
                ""
              )}
              {Break}

              {!hasAudio ? (
                <Linkify
                  properties={{
                    onClick(event) {
                      event.preventDefault();
                      window.open(event.target.href, "_blank", "noopener, noreferrer");
                    },
                  }}
                >
                  {!hasAllChar ? <p className="attentioned-users">{attentioned}</p> : ""}
                  <div className="bubble-style">
                    <span
                      id={
                        message.newMessageStatus === "sending" || message.newMessageStatus === ""
                          ? `text_${message.threadId}`
                          : `text_${message.objectId}`
                      }
                      className={`message-text-content ${!this.state.isExpanded ? "limited-text" : ""}`}
                    >
                      {this.highlightSpecificWords({
                        text: message.text,
                        highlightWords: attentioned_users,
                      })}
                    </span>
                    {message.originalMessageId && threadType === "private" && (
                      <span
                        className="text-primary badge badge-light"
                        style={{ padding: "4px 8px" }}
                        onClick={() => {
                          this.handleGoToThread(message.originalThreadId, message, message.originalMessageId);
                        }}
                      >
                        Go to message
                      </span>
                    )}
                    {threadType === "group" && (
                      <div className="task-priority-cls">
                        {[0, 1, 2].includes(message.priorityLevel) && (
                          <Fragment>
                            {message.priorityLevel === 2 && (
                              <span className="badge badge-pill badge-light priority-flex">
                                <i className="fad fa-angle-double-up fa-fw" style={{ color: "#04589e" }}></i>
                                &nbsp;High Priority
                              </span>
                            )}
                            {message.priorityLevel === 1 && (
                              <Fragment>
                                <span className="badge badge-pill badge-light priority-flex">
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      color: "#f6c23e",
                                    }}
                                  >
                                    =
                                  </span>
                                  &nbsp;
                                  <span> Medium Priority</span>
                                </span>
                              </Fragment>
                            )}
                            {/* {message.priorityLevel === 0 && (
                              <span className="badge badge-pill badge-light priority-flex">
                                <i className="text-primary fad fa-angle-double-down fa-fw"></i>
                                &nbsp; Routine Priority
                              </span>
                            )} */}
                          </Fragment>
                        )}
                        {message.actionItem && (
                          <div align="right">
                            <span
                              className="text-primary badge badge-light"
                              style={{ padding: "4px 8px" }}
                              onClick={() => {
                                this.props.openActionsModal(true, message.actionItem.objectId);
                                // window.open(
                                //   `${window.location.origin}/action-items/${message.threadId}?itemId=${message.actionItem.objectId}`,
                                //   "Hubchart Action Items"
                                // );
                              }}
                            >
                              View task
                            </span>
                          </div>
                        )}
                      </div>
                    )}
                    {moreLines && (
                      <Fragment>
                        {!this.state.isExpanded && (
                          <div align="right">
                            <span
                              className="message-text-content"
                              style={{ color: "#2193f3", cursor: "pointer" }}
                              onClick={() => this.handleViewMoreDisplay(true)}
                            >
                              Show more
                            </span>
                          </div>
                        )}
                        {this.state.isExpanded && (
                          <div align="right">
                            <span
                              className="message-text-content"
                              style={{ color: "#2193f3", cursor: "pointer" }}
                              onClick={() => this.handleViewMoreDisplay(false)}
                            >
                              Show less
                            </span>
                          </div>
                        )}
                      </Fragment>
                    )}
                  </div>
                </Linkify>
              ) : (
                ""
              )}
            </div>
            {message.actionItem &&
              message.actionItem.status === "PENDING" &&
              (this.props.filterDate.date === null || isSameDate) &&
              isPast3Days && (
                <div align="right" className="followUp">
                  <span
                    className="badge"
                    style={{
                      padding: "4px 8px",
                      backgroundColor:
                        message.isSendingFollowUp == false && message.isFollowUp == true ? "#1cc88a" : "#f8f9fc",
                      color: message.isSendingFollowUp == false && message.isFollowUp == true ? "white" : "#2194f3",
                    }}
                    onClick={() => {
                      this.handleFollowUp(message);
                    }}
                  >
                    Follow up
                  </span>
                </div>
              )}
            {/* {<div align="right">
              <small>
                {moment(new Date(message.createdAt)).format('LTS')}
                {message.actionItem && (
                  <>
                  {" - "}
                  <span style={{fontStyle:'bold'}} className={message.actionItem.status === "DONE" ? "text-success font-bold" : "text-warning font-bold"}>
                    {message.actionItem.status} <i className="fas fa-check-circle"></i>
                  </span>
                  </>
                )}
              </small>
            </div>} */}
          </div>
          {!this.props.showCheckBoxes && (
            <div className="speech-menu-container">
              <div className="dropdown">
                <button
                  type="button"
                  className="btn speech-menu dropdown-toggle"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i className="fas fa-ellipsis-h"></i>
                </button>
                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a onClick={this.handleReply.bind(this)} className="dropdown-item" href="#">
                    <i className="fas fa-reply mr-1"></i>
                    Reply
                  </a>
                  <a onClick={() => this.props.openForward(message, "forward")} className="dropdown-item" href="#">
                    <i className="fas fa-share-square mr-1"></i>
                    Forward
                  </a>
                  <a onClick={() => this.props.openSelectMultiple(true)} className="dropdown-item" href="#">
                    <i className="fas fa-share-square mr-1"></i>
                    Forward multiple
                  </a>
                  <a
                    onClick={() => this.props.handleSetTaskAndMessage(true, text, true)}
                    className="dropdown-item"
                    href="#"
                  >
                    <i className="fas fa-tasks mr-1"></i>
                    Set as new Task
                  </a>
                  <div className="dropdown-divider"></div>
                  <a
                    onClick={() => this.props.toggleEditMessage(text, message.objectId)}
                    className={`dropdown-item ${this.props.showEditMessageBox || message.actionItem ? "disabled" : ""}`}
                    href="#"
                  >
                    <i className="fas fa-pencil-alt mr-1"></i>
                    Edit message
                  </a>
                  {isPicture && (
                    <a
                      onClick={() => this.props.toggleEditImage(message)}
                      className={`dropdown-item ${
                        this.props.showEditMessageBox || message.actionItem ? "disabled" : ""
                      }`}
                      href="#"
                    >
                      <i className="fas fa-pen-square fa-lg mr-1"></i>
                      Edit Image
                    </a>
                  )}
                  {hasPDF && ( //hasPDF
                    <a
                      onClick={() => this.props.toggleEditImage(message)}
                      className={`dropdown-item ${
                        this.props.showEditMessageBox || message.actionItem ? "disabled" : ""
                      }`}
                      href="#"
                    >
                      <i className="fa fa-file-pdf fa-lg mr-1"></i>
                      Edit PDF
                    </a>
                  )}
                  <div className="dropdown-divider"></div>
                  <a onClick={() => this.props.toBeDelete()} className="dropdown-item" href="#">
                    <i className="fas fa-trash mr-1"></i>
                    Delete for myself
                  </a>
                  <a onClick={() => this.props.toBeDeleteForEveryone()} className="dropdown-item" href="#">
                    <i className="fas fa-trash mr-1"></i>
                    Delete for everyone
                  </a>
                  {isCCM && (
                    <a onClick={() => this.props.openForwardToCCM()} className="dropdown-item" href="#">
                      Forward To CCM
                    </a>
                  )}
                </div>
              </div>
              {/* <ul><li className="transform-btn" onClick={this.handleReply.bind(this)}>Reply</li></ul> */}
              {threadType != "private" && (
                <button type="button" className="btn speech-menu" onClick={() => this.props.openReminder(text)}>
                  <i className="fas fa-business-time"></i>
                </button>
              )}
              <div className="dropup">
                <button
                  type="button"
                  className="btn speech-menu"
                  id="dropdownMenuReaction"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i className="fas fa-plus"></i>
                </button>
                <div
                  className="dropdown-menu dropdown-reaction me-drop-reaction"
                  aria-labelledby="dropdownMenuReaction"
                >
                  <div className="d-flex flex-row justify-content-center align-items-center ">
                    {!rcLoading ? (
                      <>
                        <a
                          className={`dropdown-item px-1 ${userReact === ":check:" ? "react-active" : ""}`}
                          href="#!"
                          onClick={() => this.handleMessageReaction(message, ":check:", reactionId, userReact)}
                        >
                          <i className="fas fa-check text-success"></i>
                        </a>
                        <a
                          className={`dropdown-item px-1 ${userReact === ":thumbsup:" ? "react-active" : ""}`}
                          href="#!"
                          onClick={() => this.handleMessageReaction(message, ":thumbsup:", reactionId, userReact)}
                        >
                          <i className="fas fa-thumbs-up text-warning"></i>
                        </a>
                        <a
                          className={`dropdown-item px-1 ${userReact === ":question:" ? "react-active" : ""}`}
                          href="#!"
                          onClick={() => this.handleMessageReaction(message, ":question:", reactionId, userReact)}
                        >
                          <i className="fas fa-question text-danger"></i>
                        </a>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
          {this.props.showCheckBoxes && (
            <div
              className="_avatar-column"
              style={{
                display: "flex",
                marginRight: "auto",
              }}
            >
              <div className="acR acr-flex">
                {/* <input
                                    key={isChecked}
                                    type="checkbox"
                                    onClick={e => {
                                        const { checked } = e.target;
                                        this.props.handleCheckUncheckMessages(checked);
                                    }}
                                    checked={isChecked || false}
                                /> */}
                <div className="round-small" onClick={() => this.props.handleCheckUncheckMessages(!isChecked)}>
                  <input type="checkbox" id="selectAll" name="selectAll" checked={isChecked} />
                  <label for="checkbox"></label>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="me-react">
          {countCheck > 0 && <CustomReaction data={message} count={countCheck} reaction={"check"} users={usersCheck} />}
          {countThumbsUp > 0 && (
            <CustomReaction data={message} count={countThumbsUp} reaction={"thumbsup"} users={usersThumbsUp} />
          )}
          {countQuestion > 0 && (
            <CustomReaction data={message} count={countQuestion} reaction={"question"} users={usersQuestion} />
          )}
        </div>
        <div className="me-name">
          <div>
            <span>{themDate}</span> {message.edited && "(edited) "}
            {message.actionItem && (
              <>
                <span style={{ fontSize: "8px" }}>&#9679;</span>{" "}
                <span
                  style={{ fontStyle: "bold" }}
                  className={message.actionItem.status === "DONE" ? "text-success font-bold" : "text-warning font-bold"}
                >
                  {message.actionItem.status || "PENDING"} <i className="fas fa-check-circle"></i>
                </span>
              </>
            )}
          </div>
        </div>
        <div className="me-seen">
          {lastSeenBy.length > 0 && (
            <>
              {lastSeenBy.map((member) => (
                <div className="seen-profile-pic" data-tip data-for={`seen_${message.objectId}`}>
                  <img src={(member.picture || {}).url} />
                </div>
              ))}
              <ReactTooltip id={`seen_${message.objectId}`} className="reaction-tooltip" place="left">
                {lastSeenBy.map((item) => (
                  <React.Fragment key={item.objectId}>
                    {item.displayName}
                    <br />
                  </React.Fragment>
                ))}
              </ReactTooltip>
            </>
          )}
        </div>
        <div className="me-name" style={themNameStyle}>
          <span style={{ paddingLeft: "4px" }}>{message.newMessageStatus === "sending" ? "Sending..." : null}</span>
          {message.newMessageStatus === "error" ? (
            <a href="#!" onClick={this.resendMessage} style={{ paddingLeft: "4px", color: "#D84B55" }}>
              This message was not sent, Click to resent.
              <i className="fas fa-exclamation-circle" style={{ marginLeft: "2px" }}></i>
            </a>
          ) : null}
        </div>
        <div style={seenContainer}>{SeenArray}</div>
      </li>
    );
  }
}

const CustomReaction = ({ data, count, reaction, users }) => {
  let iconClass =
    reaction === "check"
      ? "fa-check text-success"
      : reaction === "thumbsup"
      ? "fa-thumbs-up text-warning"
      : reaction === "question"
      ? "fa-question text-danger"
      : "";

  return (
    <>
      <span className="badge bd-reaction mx-1" data-tip data-for={`${reaction}_${data.objectId}`}>
        <i className={`fas ${iconClass}`}></i> {count > 1 ? count : ""}
      </span>
      <ReactTooltip id={`${reaction}_${data.objectId}`} html={true} className="reaction-tooltip" place="left">
        {users.join("<br />")}
      </ReactTooltip>
    </>
  );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {
  setAttentionedMessage,
  createThread,
  sendFollowUp,
})(FromMe);
